<script>
    // @ts-nocheck
    import Typography from '$lib/components/UI/Typography.svelte'
    import Reclamo from './Reclamo.svelte'
    import { createDerivedWithFields } from '$lib/services/collections/offers'
    import ChatlistItem from '$lib/custom/components/ChatlistItem2.svelte'
    import ScrollBox from '$lib/components/UI/ScrollBox.svelte'
    import { onMount } from 'svelte'
    import { Filter, CloseCircle } from '$lib/components/Icons'
    import { API_URL } from '$lib/conf.js'
    import { fly, slide } from 'svelte/transition'
    import { cubicOut } from 'svelte/easing'
    import { Alert, MultiSelect, InputText, InputDate, FormBox, Row, TertiaryButton, Button } from '$lib/components/UI'
    import user from '$lib/stores/user'
    import Spinner from '$lib/components/UI/Spinner.svelte'
    import { resolveObjectKey, sortBy } from '$lib/utils'

    let account = user.getCurrentAccount()
    let offers = createDerivedWithFields($account, ['id', 'id_licitacion', 'vehiculo.patente:patente', 'id_siniestro'])

    let compactClaimsList = []
    let selectedClaim = null

    const getClaims = async () => user.fetch(
            `${API_URL}/claims/${user.currentAccount}?limit=0&listview=true`
        )
        .then(async req => {
            if (req.ok) {
                let { data } = await req.json()
                let open = data.filter(claim=>claim.state!='Finalizado').toSorted((a,b)=>
                    a?.last_message?.modified_date>b?.last_message?.modified_date ?
                    -1 :a?.last_message?.modified_date==b?.last_message?.modified_date ?
                    0:1
                )          
                let closed = data.filter(claim=>claim.state=='Finalizado').toSorted((a,b)=>
                    a?.last_message?.modified_date>b?.last_message?.modified_date ?
                    -1:a?.last_message?.modified_date==b?.last_message?.modified_date ?
                    0:1
                )          
                data = open.concat(closed)
                console.log(data)
                let ret = data.map((claim) => ({...claim, selected: false}))
                compactClaimsList = ret
                return ret
            } else {
                throw new Error(`Error al traer reclamos.`)
            }
        })
        .catch(e => {
            console.error(e)
            return []
        })

    const getClaimById = async (id, customFields={}) => {
        let query = ''
        const req = await user.fetch(
            `${API_URL}/claims/${user.currentAccount}/${id}`
        )
        if (req.ok) {
            let data = await req.json()
            console.log({'s': selectedClaim})
            selectedClaim = {...data, ...customFields}
        } else {
            throw new Error(`Error al traer reclamos.`)
        }
    }

    const selectClaim = (id) => {
        compactClaimsList = compactClaimsList.map((claim) => ({
            ...claim,
            selected: claim.id == id ? true : false,
        }))
    }
    let currentChat = null
    let allClaims = {}
    $: if(compactClaimsList || $offers) {
        allClaims = compactClaimsList.map(claim => {
            let {id, ...data} = ($offers || []).find(o => o.id === claim.id_oferta) || {}
            return {...claim, ...data}
        })
    }
    let heightDiv
    let showFilters = false
    const statesOptions = [{value: 'Finalizado', label: 'Finalizado'}, {value: 'Por responder', label: 'Pendiente'}, {value: 'Pendiente', label:"Por responder"}]
    let filters = {}
    $: filtered = allClaims
        /* Siniestro */
        ?.filter(c => {
            if(filters.siniestro) {
                return new RegExp(`^.*${filters.siniestro}.*$`,'i').test(c.id_siniestro)
            }
            return true
        })
        /* Patente */
        ?.filter(c => {
            if(c.patente){
                if(filters.patente) {
                    return new RegExp(`^.*${filters.patente}.*$`,'i').test(c.patente.replace(/\W*/g, ''))
                }
                return true
            }
            return false
        })
        /* Estado */
        ?.filter(c => {
            if(filters.state && filters.state.length) {
                return filters.state.includes(c.state)
            }
            return true
        })
        /* Fecha */
        ?.filter(c => {
            let {fecha_desde, fecha_hasta} = filters
            if(fecha_desde || fecha_hasta) {
                let { creation_date } = c
                let date = new Date(creation_date)
                let from = fecha_desde ? new Date(fecha_desde+'T00:00:00-03:00') : null
                let until = fecha_hasta ? new Date(fecha_hasta+'T23:59:59.999-03:00') : null
                if(from && until) {
                    if(!(from.getTime() > until.getTime())) {
                        return date.getTime() >= from.getTime() && date.getTime() <= until.getTime()
                    }
                    console.error('La fecha desde no puede ser mayor que fecha hasta')
                    return true
                } else if(from) {
                    return date.getTime() >= from.getTime()
                } else {
                    return date.getTime() <= until.getTime()
                }
            }
            return true
        })
</script>

<div style="display: flex; flex-direction: row; justify-content:space-between">
    <Typography type="h2" style="margin:0;">Reclamos</Typography>
    <TertiaryButton icon={showFilters ? CloseCircle : Filter}  on:click={() => {
        showFilters = !showFilters
    }} >{showFilters ? 'Ocultar filtros' : 'Mostrar filtros'}</TertiaryButton>
</div>
{#if showFilters}
<div transition:slide|locale={{easing: cubicOut, duration: 500}}>
    <FormBox.Container title="Filtrar" style="border-radius: 15px">
        <Row style="padding: 30px 30px 0 30px">
            <InputText label="Patente" bind:value={filters.patente}/>
            <InputText label="Siniestro" bind:value={filters.siniestro}/>
            <MultiSelect bind:value={filters.state} label="Estado" strict options={statesOptions} maxItems={statesOptions.length}/>
        </Row>
        <Row style="padding: 0 30px">
            <InputDate label="Desde" bind:value={filters.fecha_desde} />
            <InputDate label="Hasta" bind:value={filters.fecha_hasta} />
        </Row>
        <Row style="padding-bottom: 15px">
            <Button label="Limpiar busqueda" on:click={() => {
                filters = {
                    patente: '',
                    state: [],
                    siniestro: ''
                }
            }} />
        </Row>
    </FormBox.Container>
</div>
{/if}
<div class="container" class:no_selected_claim={!currentChat} bind:clientHeight={heightDiv}>
    <div class="chats_list">
        <!-- <div class="chats_list_title">
        </div> -->
        {#await getClaims()}
            <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;gap:1rem;margin:2rem">
                <div>Obteniendo reclamos...</div>
                <div><Spinner size="40" /></div>
            </div>
        {:then _}
            <ScrollBox width="100%" height="700px">
                <div style="display:flex;flex-direction:column;">
                    {#if filtered.length > 0}
                        {#each filtered as compactClaim (compactClaim.id)}
                            <ChatlistItem
                                {compactClaim}
                                on:click={() => {

                                    if(compactClaim.id !== selectedClaim?.id) {
                                        currentChat = compactClaim.id 
                                        getClaimById(compactClaim.id, {patente: compactClaim.patente})
                                        selectClaim(compactClaim.id)
                                    }
                                }}
                                selected={currentChat == compactClaim.id}
                            />
                            <!-- bind:selected={compactClaim.selected} -->
                        {/each}
                    {:else}
                        <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;gap:1rem;margin:2rem">
                            <p>No se encontraron reclamos</p>
                        </div>
                    {/if}
                </div>
            </ScrollBox>
        {:catch}
            <p>Ocurrió un error al intentar cargar reclamos.</p>
        {/await}
    </div>
    <div class="container-claim-detail">
    {#key selectedClaim}
        {#if selectedClaim == null}
            <Typography style="color: rgba(0,0,0,0.25); font-weith: 700">
                <!-- Ningún reclamo seleccionado -->
                 Seleccione un reclamo
            </Typography>
        {:else}
            <div
                in:fly={{x: -50, duration: 500, delay: 500}}
                style="width: 100%; height: 100%; position: absolute; border-radius: 15px"
                out:fly={{x: 50, duration: 500}}
            >
                <Reclamo claim={selectedClaim} back={false} style="height:72vh;" />
            </div>
        {/if}
    {/key}
    </div>
</div>

<style>
    .container {
        display: grid;
        margin: 15px 0 0 0;
        grid-template-columns: minmax(400px, 1fr) 15px 3fr;
        height: calc(100%-72px);
        position: relative;
        transition: all 0.5s ease;
    }
    .no_selected_claim {
        grid-template-columns: minmax(60%, 1fr) 15px 3fr !important;
    }
    .chats_list {
        /* padding: 1rem; */
        /* padding-right: .2rem; */
        /* padding-bottom: 0; */
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        position: relative;
        height: 100%;
        transition: all 1.5s ease-in-out;
        border-radius: 15px;
        clip-path: inset(0% 0% 0% 0% round 15px);
        /* box-shadow: 1px 1px 7px 4px rgba(0,0,0,0.23);
        -webkit-box-shadow: 1px 1px 7px 4px rgba(0,0,0,0.23);
        -moz-box-shadow: 1px 1px 7px 4px rgba(0,0,0,0.23); */
    }
    /* .chats_list_title {
        padding: 1rem;
    } */
    .container-claim-detail {
        display: flex;
        position: relative;
        justify-content: center;
        grid-column: 3;
        height: 100%;
        align-items: center;
        border-radius: 9;
        clip-path: inset(0% 0% 0% 0% round 15px);
    }
</style>
